import { Component, Input, OnInit } from '@angular/core';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { IGridState, PageSize } from 'src/app/core/models/base';
import { AbsenceState, AbsenceType } from 'src/app/time-tracking/models/absence-group';
import { AbsenceGroupStoreService } from 'src/app/time-tracking/storage/absence-group-store.service';

@Component({
    selector: 'app-absence-group-grid',
    templateUrl: './absence-group-grid.component.html',
    styleUrls: ['./absence-group-grid.component.css'],
    standalone: false
})
export class AbsenceGroupGridComponent implements OnInit {

  constructor(
    private absenceGroupStore: AbsenceGroupStoreService
  ) { }

  public absenceGroups$ = this.absenceGroupStore.absenceGroups$;

  @Input() public isAdminView: boolean = false;

  // Review view: adds the multi-select checkbox column + "confirm selected" bulk action.
  @Input() public reviewMode: boolean = false;

  // Self-service view ("my absences"): lets the absentee pull back their own request while it is
  // still open. The backend allows this for the absentee only, and only in state Open.
  @Input() public canWithdraw: boolean = false;

  public selectedIds: string[] = [];

  ngOnInit(): void {
  }

  onConfirmSelected(){
    this.absenceGroupStore.confirmAbsenceGroups(this.selectedIds);
    this.selectedIds = [];
  }

  gridState: IGridState = {
    pageSize: this.absenceGroupStore.searchAbseceGroupRequest.pageSize,
    skip: 0,
  };

  get pageSizes() {
    return PageSize;
  }

  get absenceTypes(){
    return AbsenceType;
  }

  get absenceStates(){
    return AbsenceState;
  }

  onPageSizeChange(pageSize: number) {
    this.onPageChange({ skip: this.gridState.skip, take: pageSize });
  }

  onGridReload() {
    this.absenceGroupStore.loadAbsenceGroups();
  }

  onPageChange({ skip, take }: PageChangeEvent) {
    const page = Math.round((skip + take) / take);

    this.gridState.skip = skip;
    this.gridState.pageSize = take;

    this.absenceGroupStore.searchAbseceGroupRequest.pageNumber = page;
    this.absenceGroupStore.searchAbseceGroupRequest.pageSize = take;

    this.absenceGroupStore.loadAbsenceGroups();
  }

  onAcceptAbsence(id: string){
    this.absenceGroupStore.updateAbsenceGroupState(id, this.absenceStates.Accepted);
  }

  onDeclineAbsenceGroup(id: string){
    this.absenceGroupStore.updateAbsenceGroupState(id, this.absenceStates.Declined);
  }

 
  onDeleteAbsence(id: string){
    this.absenceGroupStore.deleteAbsenceGroup(id);
  }

  onWithdrawAbsence(id: string){
    this.absenceGroupStore.withdrawAbsenceGroup(id);
  }

}
